// Third-party imports
import $ from 'jquery';

// Local imports
import { push_data_object } from '../datalayer/gtm/gtm_push.js';

// Module name
export const MODULE_NAME = 'header';

export let global_vars = {};

let popupTimeout;

export function initialize(global) {
    initSearch();
    initLanguageMenu();
    initMobileHamburger();
    initDesktopHamburger();
    initMobileNav();
    initCloseNav();
    initCloseNavWhenNavigating();
    initCloseDesktopNav();
    initNavBarAccessibility();
    initGlobalEscKeyHandler(global);
    initLangToggleLoseFocus(global);
    initHeaderCartButton(global);
    initAddToCartPopup(global);
    initNavA11yFocusOrder();
    removeBBBLogo();
}

function initSearch() {
    let searchToggle = $('.siteHeader-searchToggle svg'),
        toggleClose = $('.siteHeader-searchToggle .toggle-close'),
        searchWrapper = $('.grid-search-wrapper');
    searchToggle.on('keypress click', function(e) {
        if (e.which === 13 || e.type === 'click') {
            searchWrapper.addClass('show');
            toggleClose.addClass('show');
            $('input.gsc-input')
                .focus()
                .attr('type', 'search');
        }
    });
}

function initLanguageMenu() {
    let langWrapper = $('.site-lang-wrapper'),
        dropdown = $('.lang-selector-container li:last-child a'),
        langToggle = $('.site-lang');

    langWrapper.on('keypress click', function(e) {
        if (e.which === 13 || e.type === 'click') {
            langWrapper.toggleClass('show');
            langWrapper.hasClass('show')
                ? langToggle.attr('aria-expanded', 'true')
                : langToggle.attr('aria-expanded', 'false');
        }
    });
    dropdown.on('blur', function() {
        langWrapper.removeClass('show');
        langToggle.attr('aria-expanded', 'false');
    });
}

function initMobileHamburger() {
    let hamburgerIcon = $('.siteHeader-hamburger');
    hamburgerIcon.on('keypress click', function(e) {
        let mainNav = $('.main-nav'),
            overlay = $('header .main-overlay'),
            animateMenu = $('.siteHeader-nav'),
            mwvLogin = $('a.siteHeader-navItem.btn-mwv-login');
        if (e.which === 13 || e.type === 'click') {
            mainNav.attr('data-open-by', 'mobile').toggleClass('nav-visible');
            overlay.toggleClass('show');
            animateMenu.animate({ left: '0' }, 1000).addClass('show');
            mwvLogin.focus();

            // Add tabIndex for the close button
            $('.wrapper-close, .wrapper-close.siteHeader-close').attr(
                'tabindex',
                0
            );
        }
    });
}

function initDesktopHamburger() {
    let desktopHamburger = $('.siteHeader-desktopHamburger');

    desktopHamburger.on('keypress click', function(e) {
        if (e.which === 13 || e.type === 'click') {
            let mainNav = $('.main-nav');

            mainNav.attr('data-open-by', 'desktop');
            $('.nav-sub-menu .menu-collapse .side-nav').removeClass('u-hide');
            $('.sub-menu-bottom').removeClass('u-hide');

            mainNav.toggleClass('nav-visible');
            $('header .main-overlay').toggleClass('show');
            $('.siteHeader-navExtra')
                .animate(
                    { left: '0' },
                    {
                        duration: 1000,
                        complete: function() {},
                    }
                )
                .addClass('show');
            if (e.which === 13) {
                // Make it focused only when the nav side bar is opened by keyboard.
                $(
                    '.nav-sub-menu .menu-collapse .side-nav > ul > li:first-child > a'
                ).focus();
            }
        }
    });
}

function initMobileNav() {
    let selector = $('header.siteHeader span.siteHeader-navItem.menu-title');
    selector.on('click', function() {
        let mainNav = $('.main-nav');

        if (mainNav.attr('data-open-by') === 'mobile') {
            $('.sub-menu-bottom').toggleClass('u-hide');
            $('#sidenav').toggleClass('u-hide');

            selector.toggleClass('collapsed');
        }
    });
}

function initCloseNav() {
    let selector = $(
        '.wrapper-close, .wrapper-close.siteHeader-close, .main-overlay'
    );

    selector.on('keypress click', function(e) {
        let mainNav = $('.main-nav'),
            nav = $('.siteHeader-nav'),
            navExtra = $('.siteHeader-navExtra'),
            headerOverlay = $('header .main-overlay'),
            menuTitle = $('.nav-sub-menu .menu-title');

        if (e.which === 13 || e.type === 'click') {
            if (mainNav.attr('data-open-by') === 'mobile') {
                if (mainNav.hasClass('nav-visible')) {
                    nav.animate(
                        { left: '-90vw' },
                        {
                            duration: 1000,
                            complete: function() {
                                nav.removeClass('show');
                                mainNav.removeClass('nav-visible');
                                headerOverlay.removeClass('show');
                                $('.sub-menu-bottom').addClass('u-hide');
                                menuTitle.addClass('collapsed');

                                // Put focus back on the hamburger icon
                                $('.siteHeader-hamburger').focus();

                                // Remove tabIndex for the close button
                                $(
                                    '.wrapper-close, .wrapper-close.siteHeader-close'
                                ).attr('tabindex', -1);
                            },
                        }
                    );
                }
            } else if (mainNav.attr('data-open-by') === 'desktop') {
                if (mainNav.hasClass('nav-visible')) {
                    navExtra.animate(
                        { left: '-350px' },
                        {
                            duration: 1000,
                            complete: function() {
                                navExtra.removeClass('show');
                                mainNav.removeClass('nav-visible');
                                headerOverlay.removeClass('show');
                                menuTitle.removeClass('collapsed');
                            },
                        }
                    );
                }
            }
        }
    });
}

function initCloseNavWhenNavigating() {
    $('.nav-sub-menu .side-nav span').on('click', function() {
        let mainNav = $('.main-nav'),
            nav = $('.siteHeader-nav');
        if (mainNav.hasClass('nav-visible')) {
            nav.removeClass('show');
            mainNav.removeClass('nav-visible');
        }
    });
}

function initCloseDesktopNav() {
    let closeButton = $('.wrapper-close, .wrapper-close.siteHeader-close');
    closeButton.on('keydown', function(e) {
        let mainNav = $('.main-nav'),
            navExtra = $('.siteHeader-navExtra');
        if (
            mainNav.attr('data-open-by') === 'desktop' &&
            mainNav.hasClass('nav-visible')
        ) {
            if (e.which === 13) {
                navExtra.animate(
                    { left: '-350px' },
                    {
                        duration: 1000,
                        complete: function() {
                            navExtra.removeClass('show');
                            mainNav.removeClass('nav-visible');
                            $('header .main-overlay').removeClass('show');

                            // Put the focus on the hamburger menu on 'Top bar'
                            $('.siteHeader-desktopHamburger').focus();
                        },
                    }
                );
            }
        }
    });
}

function initNavBarAccessibility() {
    let mwvLoginSelector = $('a.siteHeader-navItem.btn-mwv-login'),
        closeButton = $('.wrapper-close, .wrapper-close.siteHeader-close');

    mwvLoginSelector.on('keydown', function(e) {
        if (e.which === 9 && e.shiftKey) {
            closeButton.focus();
            e.preventDefault();
        }
    });

    closeButton.on('keydown', function(e) {
        if (e.which === 9 && closeButton.width() > 0) {
            if (!e.shiftKey) {
                mwvLoginSelector.focus();
                e.preventDefault();
            }
        }
    });
}

function initGlobalEscKeyHandler(global) {
    global.onkeydown = function(evt) {
        if (evt.keyCode === 27) {
            let mainNav = $('.main-nav'),
                navExtra = $('.siteHeader-navExtra'),
                o = $('header .main-overlay');
            if (
                mainNav.attr('data-open-by') === 'desktop' &&
                mainNav.hasClass('nav-visible')
            ) {
                navExtra.animate(
                    { left: '-350px' },
                    {
                        duration: 1000,
                        complete: function() {
                            navExtra.removeClass('show');
                            mainNav.removeClass('nav-visible');
                            o.removeClass('show');

                            // Put the focus on the hamburger menu on 'Top bar'
                            $('.siteHeader-desktopHamburger').focus();
                        },
                    }
                );
            }
        }
    };
}

function initLangToggleLoseFocus(global) {
    $('.grid-search').on('DOMNodeInserted', function(e) {
        if ($(e.target).hasClass('gsc-input') && $(e.target).is('input')) {
            let target = $(e.target),
                searchInputAccessibility = global.document.getElementById(
                    'searchAccessibility'
                ).value,
                langWrapper = $('.site-lang-wrapper'),
                searchWrapper = $('.grid-search-wrapper');
            target.attr('aria-label', searchInputAccessibility);
            target.on('focus', function() {
                if (langWrapper.hasClass('show')) {
                    $('.site-lang').attr('aria-expanded', 'false');
                    langWrapper.removeClass('show');
                }
                $('.siteHeader-searchToggle svg').attr('aria-expanded', 'true');
            });
            target.on('blur', function() {
                if (searchWrapper.hasClass('show')) {
                    $('.siteHeader-searchToggle svg').attr(
                        'aria-expanded',
                        'false'
                    );
                    searchWrapper.removeClass('show');
                    $('.siteHeader-searchToggle .toggle-close').removeClass(
                        'show'
                    );
                }
            });
        }
    });
}

function initHeaderCartButton(global) {
    let headerCartButton = global.document.getElementById('headerCartButton');

    // When the header basket button is clicked
    // we fire an event to the data layer, then navigate to the cart
    headerCartButton.addEventListener('click', () => {
        //== gtm-push: Header Cart button clicked ==//
        let data_object = {
            event: 'Checkout-Step 1',
            ecommerce: {
                label: 'cart',
            },
        };
        push_data_object(data_object);

        //global.document.location = '/cart';
    });
}

function initAddToCartPopup(global) {
    let cartAddPopup = global.document.querySelector('.cartAddPopup');
    let toCartButton = global.document.getElementById('cartAddToCartButton');

    // When the View Basket button is clicked inside the add to cart popup
    // we fire an event to the data layer, then navigate to the cart
    toCartButton.addEventListener('click', () => {
        //== gtm-push: View Basket clicked in add to cart popup ==//
        let data_object = {
            event: 'view basket',
            ecommerce: {
                label: global.document.location.pathname,
            },
        };
        push_data_object(data_object);

        global.document.location = '/cart';
    });

    global.window.addEventListener('scroll', () => {
        if (cartAddPopup.dataset.visible === 'true') {
            updateAddToCartPopupStyling(global);
        }
    });
}

export function showAddToCartPopup(global, isUpdate) {
    // We reassign it as a string, to allow for passing the value as a bool
    isUpdate = isUpdate.toString();
    let popup = global.document.querySelector('.cartAddPopup');
    let popupMessageElement = global.document.getElementById(
        'cartAddPopupMessage'
    );
    let headerCartButton = global.document.getElementById('headerCartButton');
    let addToCartMessage =
        isUpdate === 'true'
            ? headerCartButton.dataset.updateCartMessage
            : headerCartButton.dataset.addToCartMessage;

    popup.dataset.visible = 'true';
    popupMessageElement.innerHTML = addToCartMessage;
    updateAddToCartPopupStyling(global);
    $('.cartAddPopup').show();

    global.window.clearTimeout(popupTimeout);
    popupTimeout = setTimeout(function() {
        $('.cartAddPopup').fadeOut('slow', () => {
            hideAddToCartPopup();
        });
    }, 3000);
}

function hideAddToCartPopup() {
    let cartAddPopup = global.document.querySelector('.cartAddPopup');
    cartAddPopup.dataset.visible = 'false';
}

function updateAddToCartPopupStyling(global) {
    let doc = global.document;
    let headerInView = headerIsInViewport();
    let cartAddPopup = doc.querySelector('.cartAddPopup');
    let popupArrow = doc.querySelector('.cartAddPopup__arrow');

    // When true, the popup is docked to the header (i.e. the header is in view)
    let popupIsDocked = cartAddPopup.dataset.isdocked;
    if (headerInView && (popupIsDocked === '' || popupIsDocked === 'false')) {
        cartAddPopup.classList.remove('cartAddPopupFixed');
        popupArrow.classList.remove('arrowHidden');
        cartAddPopup.dataset.isdocked = 'true';
    } else if (
        !headerInView &&
        (popupIsDocked === '' || popupIsDocked === 'true')
    ) {
        cartAddPopup.classList.add('cartAddPopupFixed');
        popupArrow.classList.add('arrowHidden');
        cartAddPopup.dataset.isdocked = 'false';
    }
}

function headerIsInViewport() {
    let popupContainer = global.document.querySelector(
        '.cartAddPopupContainer'
    );
    let distance = popupContainer.getBoundingClientRect();
    let topOffset = 20;

    return distance.top > topOffset;
}

function updateNavElementFocus() {
    const elementSkip = document.querySelector('.skipContent');
    const elementHamburger = document.querySelector(
        '.siteHeader-hamburger.collapsed'
    );
    const elementLang = document.querySelector('.siteHeader-topItem.site-lang');
    const elementLogo = document.querySelector('.siteHeader-logoLink');
    const elementSearch = document.querySelector('.siteHeader-searchToggle');
    const elementCart = document.querySelector('.siteHeader-basket');
    const elementSearchToggleMobile = document.querySelector(
        '.search-toggle-mobile'
    );

    if (window.innerWidth <= 1260) {
        elementSkip.setAttribute('tabindex', '1');
        elementHamburger.setAttribute('tabindex', '2');
        elementLang.setAttribute('tabindex', '3');
        elementLogo.setAttribute('tabindex', '4');
        elementSearch.setAttribute('tabindex', '5');
        elementCart.setAttribute('tabindex', '6');
        // remove tab 0
        elementSearchToggleMobile.removeAttribute('tabindex');
    } else {
        elementSkip.removeAttribute('tabindex');
        elementHamburger.removeAttribute('tabindex');
        elementLogo.removeAttribute('tabindex');
        elementSearch.removeAttribute('tabindex');
        elementCart.removeAttribute('tabindex');
        // readd tab 0
        elementLang.setAttribute('tabindex', '0');
        elementSearchToggleMobile.setAttribute('tabindex', '0');
    }
}

function initNavA11yFocusOrder() {
    // add event handler instead of overwriting
    window.addEventListener('load', updateNavElementFocus());
    window.addEventListener('resize', updateNavElementFocus());
}

function removeBBBLogo(){
    document.addEventListener("DOMContentLoaded", () => {
        const shadowHost = document.querySelector('wvc-legal-footer');
        const shadowRoot = shadowHost.shadowRoot;
        
     
        // Create a MutationObserver to detect when the shadow DOM has been populated with content
        const observer = new MutationObserver((mutationsList, observer) => {
            // Check for mutations that add child elements to the shadow DOM
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    // Query for <li> elements under the class 'third-party-organizations-container'
                    const liTags = shadowRoot.querySelectorAll('.third-party-organizations-container li');
                    if (liTags.length > 1) {
                        // Get the second <li> element (index 1)
                        const secondLi = liTags[1];
                        //console.log('Second <li> tag:', secondLi);
                       
                        // Apply display: none to the second <li>
                        secondLi.style.display = 'none';
     
                        observer.disconnect(); // Stop observing after content is loaded
                    }
                }
            }
        });
     
        // Observe for added nodes inside the shadow root
        observer.observe(shadowRoot, { childList: true, subtree: true });
    });
}